import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Search, Gauge, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "zuntria_truffl_tour_done";
const STEPS = [
  { icon: Search, color: "text-primary bg-primary/10", tKey: "s1" },
  { icon: Gauge, color: "text-emerald-500 bg-emerald-500/10", tKey: "s2" },
  { icon: Wand2, color: "text-accent bg-accent/10", tKey: "s3" },
];

export const TrufflTour = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!window.localStorage.getItem(KEY)) setOpen(true);
  }, []);

  const close = () => {
    window.localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  if (!open) return null;
  const s = STEPS[step];
  const Icon = s.icon;
  const last = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-background/70 p-6 backdrop-blur-sm" data-testid="truffl-tour">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-card p-6 shadow-2xl">
        <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${s.color}`}>
          <Icon className="h-6 w-6" />
        </div>
        <h3 className="mt-4 font-display text-xl" data-testid="tour-step-title">{t(`tour.${s.tKey}_title`)}</h3>
        <p className="mt-2 text-sm text-muted-foreground">{t(`tour.${s.tKey}_body`)}</p>
        <div className="mt-5 flex items-center justify-between">
          <div className="flex gap-1.5">
            {STEPS.map((_, i) => (
              <span key={i} className={`h-1.5 rounded-full transition-all ${i === step ? "w-6 bg-primary" : "w-1.5 bg-secondary"}`} />
            ))}
          </div>
          <div className="flex gap-2">
            {!last && (
              <Button variant="ghost" size="sm" onClick={close} data-testid="tour-skip-btn">
                {t("tour.skip")}
              </Button>
            )}
            <Button size="sm" onClick={() => (last ? close() : setStep(step + 1))} data-testid="tour-next-btn">
              {last ? t("tour.done") : t("tour.next")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
